export const DismissReason=Object['freeze']({'cancel':'cancel','backdrop':'backdrop','close':'close','esc':'esc','timer':'timer'});